import React from 'react';
import { Loading } from '@match/react-component-library';
import { useContactDetails } from 'modules/hooks';

const ContactUsChatPage: React.FunctionComponent<{}> = () => {
  const { contactDetails, isLoading } = useContactDetails();

  return isLoading ? (
    <Loading />
  ) : (
    <iframe src={contactDetails.chat.url} height={800} frameBorder="none" width={400} />
  );
};

export default ContactUsChatPage;
